import { Builder } from '@builder.io/react';
import image from '@/assets/images/cms/productCard.svg?inline';

export interface ProductCardComponentProps {
	readonly selectedProduct: SelectedProduct;
}

export interface SelectedProduct {
	readonly id: string;
	readonly segmentId: string;
}

const register = <TProps extends ProductCardComponentProps>(Component: React.FC<TProps>): void => {
	Builder.registerComponent(Component, {
		name: 'ProductCard',
		image,
		inputs: [
			{
				name: 'selectedProduct',
				type: 'Bizzkit ECS Product',
			},
		],
	});
};

export default register;
